import { useContext, createContext } from 'react'

export const TenantFormContext = createContext(null)

export const useTenantFormContext = () => {
  return useContext(TenantFormContext)
}
